'use strict';

const util = require('../utils/util');
const uniform = require('../components/uniform');
const pdpsize = require('../components/product/pdpsize');
const offcanvasdialog = require('../components/offcanvasdialog');
const variationValidation = require('../pages/product/validVariation');
const progress = require('../utils/progress');
const ajax = require('../utils/ajax');
const showpassword = require('../utils/showpassword');
const validator = require('../utils/validator');
const friendlyCaptcha = require('../widgets/friendlyCaptcha');
const flyinLoginForm = require('./flyinLoginForm');

const RESERVATION_FORM_SELECTOR = '.js-reservation-form';
const STORE_LOCATOR_FORM_SELECTOR = '.js-storeinventory-locator';

function activateRegionGroup(regionGroups, selectedRegion) {
    $(regionGroups).removeClass('active activeSize');
    $(regionGroups)
        .filter(function () {
            return $(this).attr('id') === selectedRegion;
        })
        .addClass('active activeSize');
}

function initOffCanvasDialog() {
    offcanvasdialog.init(
        'fly-in-link-store-inventory',
        {
            overlay: true,
            reloadContentAlways: true,
            closeOnX: true,
            additionalClass: 'fly-in-store-inventory-dialog member-shop-fly-in'
        },
        function ($triggerButton, $flyinContainer) {
            $flyinContainer.off('submit', '.flyout-ajax-login');
            if ($flyinContainer.find('.flyout-ajax-login').length > 0) {
                flyinLoginForm.initLoginFormEvents($flyinContainer, 'signInForStoreInventory');
            } else {
                initFlyIn();
            }
        }
    );
}

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 */
function updateContent(href) {
    var flyInContentContainer = '.ocd-flyin.fly-in-store-inventory-dialog .ocd-content';
    var params = {
        format: 'ajax'
    };

    progress.show(flyInContentContainer);

    if (href.indexOf('groupSize') < 0) {
        href += '&groupSize=' + $('#groupSize').val(); // eslint-disable-line no-param-reassign
    }

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        callback: function (response) {
            $(flyInContentContainer).html(response);
            initFlyIn();
            validator.init();
            showpassword.init();
            friendlyCaptcha.init('.ocd-flyin .frc-captcha');
            $('#groupSize').val(util.getParameterByName('groupSize', href));
        }
    });
}

function initFlyIn() {
    let flyInContentContainer = '.ocd-flyin.fly-in-store-inventory-dialog .ocd-content';
    let isReservatinFlyIn = $(flyInContentContainer).find('.availability-header').data('isreserve');
    let eventProduct = $(flyInContentContainer).find('.availability-header').data('product-id');
    let eventUser = $(flyInContentContainer).find('.availability-header').data('customer-no') || '';
    uniform();
    pdpsize.init(flyInContentContainer);
    variationValidation.init();
    initVariantSelection($(flyInContentContainer));

    let searchMode = $(flyInContentContainer).find('.availability-header').data('search-mode');
    if (isReservatinFlyIn && searchMode) {
        window.dataLayer?.push({
            event: 'ga4_interaction',
            event_name: 'click_and_reserve',
            event_action: 'search_store',
            event_value: $(flyInContentContainer).find('.store-item').length,
            event_product: eventProduct,
            event_user: eventUser,
            event_input: searchMode
        });
    }

    $('body').on('click', 'a.js-reserve-in-store', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        updateContent($(this).attr('href'));
        window.dataLayer?.push({
            event: 'ga4_interaction',
            event_name: 'click_and_reserve',
            event_action: 'select_store',
            event_category: $(this).siblings('.store-name').text().trim(),
            event_product: eventProduct,
            event_user: eventUser
        });
        window.addEventListener(
            'popstate',
            function (event) {
                $(flyInContentContainer).find('.ocd-close').first().trigger('click');
            },
            false
        );
    });

    $('body').on('click', '.ocd-overlay', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $('.ocd-close').first().trigger('click');
    });

    $('body').on('click', '.fly-in-store-inventory-dialog .address-phone', function () {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'storeCalled',
                storeCalledEan: $(this).closest('.store-item').data('product-id')
            });
        }
    });

    $('body').on('click', '.stores-list .view-store', function () {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'storeAvailabilityViewStore',
                viewStoreEan: $(this).closest('.store-item').data('product-id')
            });
        }
    });

    $('body').on('click', '.ocd-close', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (isReservatinFlyIn) {
            window.dataLayer?.push({
                event: 'ga4_interaction',
                event_name: 'click_and_reserve',
                event_action: 'close_flyin',
                event_product: eventProduct,
                event_user: eventUser
            });
        }
        $('.ocd-overlay').removeClass('active right');
        offcanvasdialog.closeAll();
    });

    $('body').on('click', '.store-availability-find-stores', function () {
        let url = util.appendParamsToUrl($(this).data('target'), {action: 'findstores'});
        updateContent(url);
    });

    $('body').on('click', '.js-storereservation-not-you', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const $reservationForm = $(RESERVATION_FORM_SELECTOR);
        $reservationForm.data('triggerLogout', true);
        $reservationForm.trigger('submit');
    });

    $('body').on('click', '.js-close-confirmation', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $('.ocd-close').first().trigger('click');
    });

    $('body').on('click', '.js-login', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const $reservationForm = $(RESERVATION_FORM_SELECTOR);
        $reservationForm.data('triggerLogin', true);
        $reservationForm.trigger('submit');
    });

    $('body').on('change', 'input[name$="_usertype"]', function () {
        $('.guest, .customer').addClass('hidden');
        $('div .' + $(this).val()).removeClass('hidden');
    });

    $('body').on('click', '.js-store-btn-search-around', function () {
        let url = $(this).closest('form').data('target');

        navigator.geolocation.getCurrentPosition(function (position) {
            const location = {
                lat: position.coords.latitude,
                long: position.coords.longitude
            };

            url = util.appendParamsToUrl(url, {
                locLat: location.lat,
                locLng: location.long
            });
            updateContent(url);
        });
    });

    $('body').on('submit', STORE_LOCATOR_FORM_SELECTOR, function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const zipCitySearch = $(this).find('.js-zip-city-input').val();
        let url = $(this).data('target');
        const country = $(this).data('countryCode');

        if (zipCitySearch) {
            const googleMaps = window.google.maps;
            const geocoder = new googleMaps.Geocoder();

            geocoder.geocode(
                {address: zipCitySearch, componentRestrictions: {country: country}},
                function (results, status) {
                    if (status === 'OK' && results.length >= 1) {
                        const firstResult = results[0];
                        // If result is valid, address_components will always have lenght over 1
                        if (firstResult.address_components.length > 0) {
                            const location = {
                                lat: firstResult.geometry.location.lat(),
                                long: firstResult.geometry.location.lng()
                            };

                            url = util.appendParamsToUrl(url, {
                                locLat: location.lat,
                                locLng: location.long,
                                zipCitySearch
                            });
                            updateContent(url);
                        }
                    }
                }
            );
        } else {
            updateContent(url);
        }
    });

    $('body').on('keydown', RESERVATION_FORM_SELECTOR, function (e) {
        if (e.which === 13) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if ($(this).find('.guest').hasClass('hidden')) {
                $(this).data('triggerLogin', true);
            }
            $(this).trigger('submit');
        }
    });

    $('body').on('submit', RESERVATION_FORM_SELECTOR, function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const $form = $(this);
        let data = $form.serialize();

        if ($(this).data('triggerLogout') === true) {
            data += '&triggerLogout=true';
            $(this).removeData('triggerLogout');
        } else {
            if ($(this).data('triggerLogin') === true) {
                $(this).removeData('triggerLogin');
            } else {
                let userID = $form.find('input[name$="userid"]').val() || '';
                eventUser = userID;
                window.dataLayer?.push({
                    event: 'ga4_interaction',
                    event_name: 'click_and_reserve',
                    event_action: 'form_submit',
                    event_category: $(flyInContentContainer).find('.store-name').text().trim(),
                    event_value: $(flyInContentContainer).find('.availability-header').data('price'),
                    event_product: eventProduct,
                    event_user: userID
                });
            }
        }
        progress.show($(flyInContentContainer));
        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data,
            dataType: 'html',
            success: function (html) {
                $(flyInContentContainer).html(html);
                validator.init();
                showpassword.init();
                friendlyCaptcha.init('.ocd-flyin .frc-captcha');
            }
        });
    });
    $('.ocd-content').on(
        'click keypress',
        '.size-region a, .attribute.size .form-row-radio.region-select',
        function (event) {
            // pdp size
            if (util.isClickOrSpaceOrEnter(event)) {
                var $containers = $('.attribute.size'); // change all instances for Product Sets
                var $regionGroups = $containers.find('.sizes .RegionGroup');
                var selectedRegion = '';
                if ($(this).hasClass('form-row-radio')) {
                    selectedRegion = $(this).find('input').val();
                    var $selectedRadios = $containers.find('input[value="' + selectedRegion + '"]');

                    activateRegionGroup($regionGroups, selectedRegion);

                    if ($selectedRadios && $selectedRadios.length > 1) {
                        $selectedRadios.parent('span').addClass('checked');
                    }
                } else {
                    var firstRegion = $(this).first();
                    if (firstRegion.length > 0) {
                        selectedRegion = firstRegion.text();
                    }

                    var $tabLinks = $containers.find('.size-region a');

                    $tabLinks.each(function () {
                        $(this).removeClass('tab-selected');
                        $(this).attr('aria-checked', false);
                    });
                    $(this).addClass('tab-selected');
                    $(this).attr('aria-checked', true);
                    activateRegionGroup($regionGroups, selectedRegion);
                }
            }
        }
    );
}

$(document).on(
    'click',
    '.fly-in-link-store-inventory:not(.availability-reminder-content .fly-in-link-store-inventory)',
    function () {
        let dataLayerObject = {};
        if ($(this).data('product-id') !== '' && $('.product-availability-links').length > 0) {
            if ($(this).data('isreserve')) {
                let userId = $(this).data('customer-no') || '';
                dataLayerObject = {
                    event: 'ga4_interaction',
                    event_name: 'click_and_reserve',
                    event_action: 'open_flyin',
                    event_product: $(this).data('variationgroup-id'),
                    event_user: userId
                };
            } else {
                dataLayerObject.event = 'storeAvailabilityClickedPdp';
                dataLayerObject.storeAvailabilityEan = $(this).data('product-id');
            }
        }

        if (window.dataLayer) {
            window.dataLayer.push(dataLayerObject);
        }
    }
);

/**
 * @description Initialize the store inventory variant selection
 */
function initVariantSelection($qsFlyInContent) {
    // click on swatch - should replace content with new variant
    $qsFlyInContent.find('.swatchanchor').on('click', function (e) {
        e.preventDefault();
        updateContent(this.href);
    });
}

exports.init = function () {
    $('body').on(
        'click',
        '.fly-in-link-store-inventory-wrapper .fylin-link, .ocd-content .flyin-product-info-size',
        function () {
            offcanvasdialog.closeAll();
        }
    );

    initOffCanvasDialog();

    if (sessionStorage.getItem('signInForStoreInventory')) {
        $('.fly-in-link-store-inventory:not(.availability-reminder-content .fly-in-link-store-inventory)').click();
    }
    sessionStorage.removeItem('signInForStoreInventory');
};
